// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__1nROp","row":"Node_row__26JP8","label":"Node_label__2Mb-l","footer":"Node_footer__3rK5X"};